import { Component, HostListener, ElementRef, ViewChild } from '@angular/core';
import { VERSION as aldAppVERSION } from '../../version/version';

import { AuthenticationService } from '../../../../../../src/app/shared/services/authentication.service';
import { EnvironmentService } from '../../../../../../src/app/services/environment.service';

import { BannerService } from '../../../../../../src/app/shared/services/banner.service';
import { HelperService } from '../../../../../../src/app/services/helper/helper.service';

import { Store, Select, StateContext } from '@ngxs/store';
import { Observable } from 'rxjs';

import * as Models from '../../../../../../src/app/models/commonModels';
import { Router } from '@angular/router';


@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss']
})

export class LayoutComponent {
  public version = 'develop';

  public portalType: string;


 

  constructor(
    private el: ElementRef,
    private store: Store,
    private authenticationService: AuthenticationService,
    private helper: HelperService,
    private environment: EnvironmentService,
    private banner: BannerService,
    private router: Router
    ) {

  }
}


